import { Button as ButtonBase, type ButtonProps } from '@shared/ui-components/button/button';

import { withCustomLinkComponent } from '../../i18n/with-custom-link-component';

export const Button = (props: Omit<ButtonProps, 'LinkComponent'>) =>
  withCustomLinkComponent(ButtonBase, props);
